<template>

  <div
    class="buymodal-block__header">

    <div
      class="header-item"
      v-for="(item, i) in headers" :key="i"
      :class="item.active ? 'active' : ''">
      <span
        class="circle">
        {{ i+1 }}
      </span>
      <span
        class="name">
        {{ item.name }}
      </span>
    </div>

  </div>

</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
    },
  },
};
</script>

<style lang="css">
</style>
